// Redesigned search panel — open/close behavior + inline predictive results.
(function () {
  var panel = document.querySelector('[data-redesign-search]');
  if (!panel) return;

  var panelInput = panel.querySelector('[data-redesign-search-input]');
  var closeBtn = panel.querySelector('[data-redesign-search-close]');
  var emptyState = panel.querySelector('[data-redesign-search-empty]');
  var resultsState = panel.querySelector('[data-redesign-search-results]');
  var queriesList = panel.querySelector('[data-redesign-search-queries]');
  var queriesSection = panel.querySelector('[data-redesign-search-suggestions]');
  var productsContainer = panel.querySelector('[data-redesign-search-products]');
  var productsSection = panel.querySelector('[data-redesign-search-products-section]');
  var emptyMessage = panel.querySelector('[data-redesign-search-empty-message]');
  var viewAllLinks = panel.querySelectorAll('[data-redesign-search-view-all]');
  var viewAllQueries = panel.querySelectorAll('[data-redesign-search-query]');

  var triggerSelectors = [
    '.header__icon--search',
    '.globo-search-activator',
    '.header__search-bar input[type="search"]',
    '#Inline-Search',
    '#Search-In-Modal',
    '#Search-In-Modal-1'
  ];

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function visibleHeaderInput() {
    return document.querySelector('#Inline-Search, .header__search-bar input[type="search"]');
  }

  function open() {
    panel.removeAttribute('hidden');
    document.body.classList.add('redesign-search-open');
    setHeaderBottomPosition();
    setTimeout(function () {
      var target = isDesktop() ? visibleHeaderInput() : panelInput;
      if (target && typeof target.focus === 'function') target.focus({ preventScroll: true });
    }, 30);
  }

  function close() {
    panel.setAttribute('hidden', '');
    document.body.classList.remove('redesign-search-open');
    if (panelInput) panelInput.value = '';
    var hdr = visibleHeaderInput();
    if (hdr) hdr.value = '';
    showEmptyState();
  }

  function setHeaderBottomPosition() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom-position', Math.max(rect.bottom, 0) + 'px');
  }

  function showEmptyState() {
    if (emptyState) emptyState.removeAttribute('hidden');
    if (resultsState) resultsState.setAttribute('hidden', '');
  }

  function showResults() {
    if (emptyState) emptyState.setAttribute('hidden', '');
    if (resultsState) resultsState.removeAttribute('hidden');
  }

  // --- Predictive search ---
  var fetchSeq = 0;
  var debounceTimer = null;

  function debouncedSearch(query) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { doSearch(query); }, 200);
  }

  function doSearch(query) {
    var trimmed = (query || '').trim();
    if (!trimmed) {
      showEmptyState();
      return;
    }
    // Strip punctuation that Shopify's search index chokes on (apostrophes,
    // smart quotes, parens). e.g. "pau d' arco" returns 0 from Shopify, but
    // "pau d arco" returns the product fine.
    var indexed = trimmed.replace(/[''`"()\[\]]/g, ' ').replace(/\s+/g, ' ').trim();
    var mySeq = ++fetchSeq;
    // Products come from BOTH endpoints: suggest.json prefix-matches partial
    // words ("metabo" finds Metabolism Booster Bundle) which the full /search
    // endpoint can't do — its options[prefix] is silently ignored there.
    var suggestUrl = '/search/suggest.json'
      + '?q=' + encodeURIComponent(indexed)
      + '&resources[type]=query,product'
      + '&resources[limit]=10'
      + '&resources[options][prefix]=last'
      + '&resources[options][unavailable_products]=last';
    // Custom view template `templates/search.results-json.liquid` outputs the full search
    // results as JSON. Lets us bypass the 10-result hard cap on /search/suggest.json.
    var productsUrl = '/search'
      + '?q=' + encodeURIComponent(indexed)
      + '&view=results-json'
      + '&type=product'
      + '&options[prefix]=last'
      + '&options[unavailable_products]=last';
    var jsonOpts = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    var viewOpts = { credentials: 'same-origin' }; // no Accept header — Shopify routes view= correctly
    Promise.all([
      fetch(suggestUrl, jsonOpts).then(function (r) { return r.json(); }).catch(function () { return null; }),
      fetch(productsUrl, viewOpts).then(function (r) { return r.text(); }).then(function (t) {
        try { return JSON.parse(t); } catch (e) { return null; }
      }).catch(function () { return null; })
    ]).then(function (responses) {
      if (mySeq !== fetchSeq) return; // stale response, ignore
      renderResults(responses[0], responses[1], trimmed);
    }).catch(function () {
      if (mySeq !== fetchSeq) return;
      showEmptyState();
    });
  }

  function renderResults(suggestData, productsData, query) {
    var suggestResults = (suggestData && suggestData.resources && suggestData.resources.results) || {};
    var queries = suggestResults.queries || [];
    var products = (productsData && productsData.results) || [];

    // Union with suggest.json's prefix-matched products (deduped by URL path):
    // /search supplies the full result set for whole words; suggest fills in
    // partial-word matches while the customer is still typing.
    var seenUrls = {};
    products.forEach(function (p) { seenUrls[(p.url || '').split('?')[0]] = true; });
    (suggestResults.products || []).forEach(function (p) {
      var key = (p.url || '').split('?')[0];
      if (!key || seenUrls[key]) return;
      seenUrls[key] = true;
      products.push(p);
    });

    // House-brand priority: products whose title or vendor starts with "+boost"
    // are ranked above third-party brands. Stable sort preserves Shopify's
    // original ordering within each group.
    products = products
      .map(function (p, i) { return { p: p, i: i, b: isHouseBrand(p) ? 0 : 1 }; })
      .sort(function (a, b) { return a.b - b.b || a.i - b.i; })
      .map(function (x) { return x.p; });

    // Suggestions
    if (queriesList) queriesList.innerHTML = '';
    if (queries.length > 0 && queriesList) {
      queries.forEach(function (q) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'redesign-search__suggestion';
        a.href = q.url || ('/search?q=' + encodeURIComponent(q.text || ''));
        a.textContent = q.text || '';
        li.appendChild(a);
        queriesList.appendChild(li);
      });
      queriesSection.removeAttribute('hidden');
    } else if (queriesSection) {
      queriesSection.setAttribute('hidden', '');
    }

    // Products
    if (productsContainer) productsContainer.innerHTML = '';
    if (products.length > 0 && productsContainer) {
      products.forEach(function (p) {
        productsContainer.appendChild(buildProductCard(p));
      });
      productsSection.removeAttribute('hidden');
    } else if (productsSection) {
      productsSection.setAttribute('hidden', '');
    }

    // Empty / view-all
    var hasAny = queries.length > 0 || products.length > 0;
    if (emptyMessage) {
      if (!hasAny) emptyMessage.removeAttribute('hidden'); else emptyMessage.setAttribute('hidden', '');
    }
    var searchHref = '/search?q=' + encodeURIComponent(query);
    viewAllQueries.forEach(function (el) { el.textContent = query; });
    viewAllLinks.forEach(function (el) {
      el.href = searchHref;
      el.removeAttribute('hidden');
    });

    showResults();
  }

  function buildProductCard(p) {
    var a = document.createElement('a');
    a.className = 'redesign-search__product';
    a.href = p.url || '#';

    var imgWrap = document.createElement('div');
    imgWrap.className = 'redesign-search__product-image-wrap';
    // /search.json returns `featured_image` as a URL string and also `image`; /search/suggest.json returns `featured_image` as an object.
    var fi = p.featured_image;
    var imgUrl = (fi && typeof fi === 'object' && fi.url) || (typeof fi === 'string' && fi) || p.image || '';
    var imgAlt = (fi && typeof fi === 'object' && fi.alt) || p.title || '';
    if (imgUrl) {
      var img = document.createElement('img');
      img.className = 'redesign-search__product-image';
      img.loading = 'lazy';
      img.alt = imgAlt;
      img.src = withWidth(imgUrl, 600);
      img.srcset = withWidth(imgUrl, 300) + ' 300w, ' + withWidth(imgUrl, 450) + ' 450w, ' + withWidth(imgUrl, 600) + ' 600w';
      img.sizes = '(min-width: 990px) 220px, 45vw';
      imgWrap.appendChild(img);
    }
    a.appendChild(imgWrap);

    var title = document.createElement('h3');
    title.className = 'redesign-search__product-title';
    title.textContent = p.title || '';
    a.appendChild(title);

    var price = document.createElement('p');
    price.className = 'redesign-search__product-price';
    price.textContent = formatPrice(p);
    a.appendChild(price);

    return a;
  }

  function isHouseBrand(p) {
    var t = (p.title || '').toLowerCase();
    var v = (p.vendor || '').toLowerCase();
    return t.indexOf('+boost') === 0 || v.indexOf('+boost') === 0;
  }

  function withWidth(url, w) {
    if (!url) return '';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'width=' + w;
  }

  function formatPrice(p) {
    // /search/suggest.json returns prices as already-formatted decimal strings in major units
    // (e.g. "39.99"), or already-localized strings ("€39,99"). Pass through localized strings
    // verbatim; otherwise format the decimal with the shop's currency symbol.
    var raw = p.price;
    if (raw == null) raw = p.price_min;
    if (raw == null || raw === '') return '';
    if (typeof raw === 'string' && /[€$£¥]/.test(raw)) return raw;
    var n = Number(raw);
    if (isNaN(n)) return String(raw);
    return '€' + n.toFixed(2).replace('.', ',');
  }

  // --- Wire up triggers + inputs ---
  function onTriggerClick(event) {
    if (!panel.hasAttribute('hidden')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var details = event.target.closest('details');
    if (details) {
      details.removeAttribute('open');
      var modal = details.closest('details-modal');
      if (modal) modal.removeAttribute('open');
    }
    open();
  }

  function onTriggerFocus() {
    if (!panel.hasAttribute('hidden')) return;
    open();
  }

  triggerSelectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      el.addEventListener('click', onTriggerClick);
      if (el.tagName === 'INPUT') el.addEventListener('focus', onTriggerFocus);
    });
  });

  // Listen to typing on the panel input + the legacy header input
  function attachInputListener(input) {
    if (!input) return;
    input.addEventListener('input', function (e) {
      var q = e.target.value;
      // Mirror to the other input so UX stays consistent
      if (input === panelInput) {
        var hdr = visibleHeaderInput();
        if (hdr && hdr !== input) hdr.value = q;
      } else if (panelInput && panelInput !== input) {
        panelInput.value = q;
      }
      if (!q.trim()) {
        showEmptyState();
      } else {
        // Hide popular + best sellers immediately so they aren't visible while typing
        showResults();
      }
      debouncedSearch(q);
    });
  }
  attachInputListener(panelInput);
  attachInputListener(visibleHeaderInput());

  // Close handlers
  if (closeBtn) closeBtn.addEventListener('click', close);

  panel.addEventListener('click', function (event) {
    if (!isDesktop()) return;
    if (event.target === panel) close();
  });
  document.addEventListener('click', function (event) {
    if (panel.hasAttribute('hidden')) return;
    if (!isDesktop()) return;
    var withinPanel = panel.contains(event.target);
    var onTrigger = triggerSelectors.some(function (sel) { return event.target.closest(sel); });
    // Enter in the header search input fires an implicit click on the form's submit button.
    // Without this guard, close() wipes the input before the form serializes q into the URL.
    var inSearchForm = event.target.closest('form[action$="/search"], .search-modal__form, .redesign-search__form');
    if (!withinPanel && !onTrigger && !inSearchForm) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hasAttribute('hidden')) close();
  });

  // Mobile: dismiss the soft keyboard when the user starts scrolling the panel
  // so the results area isn't pinned under the keyboard.
  panel.addEventListener('touchmove', function (event) {
    if (isDesktop()) return;
    var active = document.activeElement;
    if (active && active.tagName === 'INPUT' && panel.contains(active)) {
      active.blur();
    }
  }, { passive: true });

  window.addEventListener('resize', setHeaderBottomPosition);
  window.addEventListener('scroll', setHeaderBottomPosition, { passive: true });
  setHeaderBottomPosition();
})();
